import parse, { domToReact } from 'html-react-parser';

export const ProductDescription = ({ productDetails }: { productDetails: any }) => {
  const replacedDescription = productDetails?.description?.html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/\r\n/g, '');

  const parseOptions = {
    replace: (node: any) => {
      if (node.type === 'tag' && node.name === 'div') {
        return <> {domToReact(node.children)}</>;
      }
    },
  };

  const parsedDescription = parse(replacedDescription, parseOptions);

  return (
    <div>
      <h2 className='font-roboto-medium text-lg font-medium leading-[21px]'>Description:</h2>
      <div className='[&_ul]_pl-4.5 mb-0 mt-2.5 font-roboto-light text-[16px] font-light leading-5 lg_text-sm [&_a]_underline hover_[&_a]_text-[#f68872] [&_h4]_my-5 [&_h4]_mb-2.5 [&_h4]_mt-5  [&_ul]_list-outside [&_ul]_list-disc'>
        {parsedDescription}
      </div>
    </div>
  );
};
